var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { UserAvatar as BaseUserAvatar, userAvatarClasses as baseUserAvatarClasses, } from "@vividtheory/minerva-lab";
import React from "react";
export const userAvatarClasses = baseUserAvatarClasses;
export const UserAvatar = (_a) => {
    var { square, sx } = _a, props = __rest(_a, ["square", "sx"]);
    return (React.createElement(BaseUserAvatar, Object.assign({ sx: Object.assign({ borderRadius: (theme) => square ? theme.radius.default : theme.radius.full }, sx) }, props)));
};
//# sourceMappingURL=UserAvatar.js.map